<template>
    <div class="card" id="print-car-specs">
        <header class="card-header">
            <p class="card-header-title">Specifications:</p>
            <a href="#" class="card-header-icon" aria-label="more options">
                  <span class="icon">
                    <i class="fas fa-cogs"></i>
                  </span>
            </a>
        </header>
        <div class="">
            <div class="content">
                <table class="table">
                    <tbody>
                    <tr>
                        <th>Brand:</th>
                        <td>{{ car.company }}</td>
                    </tr>
                    <tr>
                        <th>Model:</th>
                        <td>{{ car.model_name_en }}</td>
                    </tr>
                    <tr>
                        <th>Year:</th>
                        <td>{{ car.model_year_en }}</td>
                    </tr>
                    <tr>
                        <th>Grade:</th>
                        <td><span v-html="car.grade_en"></span></td>
                    </tr>
                    <tr>
                        <th>km's:</th>
                        <td>{{ car.mileage_num }},000</td>
                    </tr>
                    <tr>
                        <th>Chassis:</th>
                        <td><strong><a href="https://jpcenter.ru/month?lang=en" target="_blank" class="has-text-danger tooltip" data-tooltip="Manufacture check">{{ car.model_type_en }} <i class="fas fa-search"></i></a></strong></td>
                    </tr>
                    <tr>
                        <th>Color:</th>
                        <td>{{ car.color_en }}</td>
                    </tr>
                    <tr>
                        <th>Transmission</th>
                        <td>{{ car.transmission_en }}</td>
                    </tr>
                    <tr>
                        <th>Displacement:</th>
                        <td>{{ car.displacement_num }}</td>
                    </tr>
                    <tr>
                        <th>Equipment:</th>
                        <td>{{ car.equipment_en }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import '../../../../../node_modules/bulma-extensions/bulma-tooltip/dist/css/bulma-tooltip.min.css';
    export default {
       props:['car']
    }
</script>

<style scoped>
    table {
        font-size: small;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cars/Car/Details/CarSpecs.vue